export namespace OCR {
  export enum ETaskState {
    Loading,  //待识别
    Working,  //识别中
    Done,  //成功
    Fail  //失败
  }
  export interface OCRListRes {
    id: string
    filename: string
    fileSize: string
    createDt: string
    language?: string | null
    progress?: number
    status: ETaskState
  }
  export interface OCRLoopRes {
    id: string
    progress: string
    status: ETaskState
  }

  export enum PropertyType {
    BizCard = 'bizcard',
    Template = 'template',
  }
  export interface PropertyItem {
    name: string,
    property: string,
    type: PropertyType
  }
}

export namespace OcrResult {
  interface IOcrPage {
    paragraphs: string[]
  }
  interface IResItem {
    docCount: string
    filename: string
    ocrPages: IOcrPage[]
    image: string
  }
  export type Res = IResItem[]

  export interface IReq {
    ocrTaskId: string
    detailVOS: Res
  }
}


export enum EnumOperated {
  COPY = 'copy',
  STICKUP = 'stickup' ,
  DELETE = 'delete',
}
